module.exports = __webpack_public_path__ + "img/ic-eatmap.74d3951e.svg";